<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <!-- <img src="@/assets/img/logo_white.png" alt="logo图"> -->
    </div>
    <p class="title">东营市财金化学有限公司</p>
    <p class="address_tel_fax">
      <span>地址：山东省东营市经济技术开发区广利临港园区渤海路168号</span>
      <span>Tel：0546-8018079</span>
    </p>
    <p class="email_wx">
      <span>邮箱：jmhgzhb@126.com</span>
      <!-- <span>微信号：xxx</span> -->
    </p>
    <p class="copy">Copyright &copy; 2025 - {{ new Date().getFullYear() }} 东营市财金化学有限公司 备案号：鲁ICP备2021031613号-2</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  /*background: #409eff;*/
  background: #0662B1;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 30px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 19px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 19px;
}
.copy {
  color: #d3d3d3;
  font-size: 19px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue